import React, { useState, useEffect } from "react";

import {
  Modal,
  ModalBody,
  Button,
  Progress,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  Popover,
  PopoverHeader,
  PopoverBody,
  Row,
  Col,
  InputGroup,
  Input,
  InputGroupAddon,
  Collapse,
  ModalHeader,
  Label,
  ModalFooter,
  UncontrolledDropdown,
  DropdownItem,
  Table,
  Card,
} from "reactstrap";
import { connect } from "react-redux";
import moment from "moment";
import axios from "../../../../axios";
import * as url from "../../../../utils/url";
import Loading from "../../../../hoc/Loading/Loading";
import Select from "react-select";
import { toastContainer } from "../../../../utils/toast";
import { TEMPLATE_TYPE_MAP, TEMPLATE_TYPE_COLORS, TEMPLATE_TYPE_CSS_CLASS, WEB_GENERATE_ERROR_MESSAGE } from "../../data";
import sortBy from "lodash.sortby";

function TrivvyCustomTemplateForm({ selectedType,handleBack,user,addTrivvySuccessFromTemplates,selectedId }) {
  const [step, setStep] = useState(1);
  const [industriesList, setIndustriesList] = useState([]);
  const [occupationsList, setOccupationsList] = useState([]);
  const [jobCatergoryList, setJobCatergoryList] = useState([]);
  const [workFlexibilityList, setWorkFlexibilityList] = useState([
    {
      label: "All",
      value: "ALL",
    },
    {
      label: "Remote/work from home (WFH)",
      value: 1,
    },
    {
      label: "In person/Work at office",
      value: 2,
    },
    {
      label: "Hybrid - work from home and/or office",
      value: 3,
    },
  ]);

  const [selectedData, setSelectedData] = useState({
    jobCategory: null,
    occupation: null,
    industry: null,
    workFlexibility: null,
  });

  useEffect(() => {
    axios.get(url.getMasterListByCategory("INDUSTRY")).then(({ data }) => {
      setIndustriesList([{name:"All",_id:"ALL"},...data.data[0].docs]);
    });

    axios.get(url.getMasterListByCategory("OCCUPATION")).then(({ data }) => {
      const payload = data.data;
      let occupationOptions = payload[0].docs.map((occupation) => {
        const o = {};
        o.value = occupation._id;
        o.label = occupation.name;
        o.definition = occupation.definition;
        return o;
      });
      occupationOptions = sortBy(occupationOptions, ["label"]);
      setOccupationsList([{label:"All",value:"ALL"},...occupationOptions]);
    });

    axios.get(url.getMasterListByCategory("SENIORITY")).then(({ data }) => {
      const payload = data.data;
      let seniorityOptions = payload[0].docs.map((seniortiy) => {
        const o = {};
        o.value = seniortiy._id;
        o.label = seniortiy.name;
        o.definition = seniortiy.definition;
        return o;
      });
      seniorityOptions = sortBy(seniorityOptions, ["label"]);
      setJobCatergoryList([{label:"All",value:"ALL"},...seniorityOptions]);
    });
  }, []);

  const nextBtnDisabled = () => {
    let val = true;

    for (const obj in selectedData) {
      const elem = selectedData[obj];
      if (elem && elem.value) {
        val = false;
      } else {
        
      }
    }

    return val;
  };

  const handleCreateTrivvy=()=>{
    const payload = {
      selectedId:selectedId,
      selectedType:selectedType,
      name:TEMPLATE_TYPE_MAP[selectedType],
      jobCategory:selectedData.jobCategory && selectedData.jobCategory.value!=="ALL" ? selectedData.jobCategory.label:null,
      occupation:selectedData.occupation && selectedData.occupation.value !=="ALL" ? selectedData.occupation.label:null,
      industry:selectedData.industry && selectedData.industry.value !=="ALL" ? selectedData.industry.label:null,
      workFlexibility:selectedData.workFlexibility && selectedData.workFlexibility.value !=="ALL" ? selectedData.workFlexibility.label:null,
      orgName:user.profile.organizationId.name
    }

    console.log(payload)

    axios.post(url.createTrivvyFromCustomTemplates,payload).then(({data})=>{
      addTrivvySuccessFromTemplates(data.data.trivvys)
    }).catch(err =>{
      toastContainer("Error while creating trivvy from template.","error")
     })
  }

  return (
    <div className="trivvy_custom_temp_form">
        <div class={`template-type-block ${TEMPLATE_TYPE_CSS_CLASS[selectedType]}`}>
        {TEMPLATE_TYPE_MAP[selectedType]}
          {/* Holiday */}
        </div>
      {/* <h5 className="text-center">
      </h5> */}
      <div className="trivvy_custom_template_form mt-5">
        <div className="content_height_warpper">
          <div className="my-4 d-flex-align-center">
            <Label>Please Select Industry</Label>
            <div
              style={{
                flex: 1,
                marginLeft: "15px",
              }}
            >
              <Select
                value={selectedData.industry}
                options={
                  industriesList
                    ? industriesList.map((i) => ({
                        value: i._id,
                        label: i.name,
                      }))
                    : []
                }
                onChange={(v) =>
                  setSelectedData({
                    ...selectedData,
                    industry: v,
                  })
                }
                clearable={false}
              />
            </div>
          </div>
          <div className="my-4 d-flex-align-center">
            <Label>Please select the job category</Label>
            <div
              style={{
                flex: 1,
                marginLeft: "15px",
              }}
            >
              <Select
                value={selectedData.jobCategory}
                options={jobCatergoryList}
                onChange={(v) =>
                  setSelectedData({
                    ...selectedData,
                    jobCategory: v,
                  })
                }
                clearable={false}
              />
            </div>
          </div>
          <div className="my-4 d-flex-align-center">
            <Label>Please select occupation</Label>
            <div
              style={{
                flex: 1,
                marginLeft: "15px",
              }}
            >
              <Select
                value={selectedData.occupation}
                options={occupationsList}
                onChange={(v) =>
                  setSelectedData({
                    ...selectedData,
                    occupation: v,
                  })
                }
                clearable={false}
              />
            </div>
          </div>
          <div className="my-4 d-flex-align-center">
            <Label>Please select work flexibility</Label>
            <div
              style={{
                flex: 1,
                marginLeft: "15px",
              }}
            >
              <Select
                value={selectedData.workFlexibility}
                options={workFlexibilityList}
                onChange={(v) =>
                  setSelectedData({
                    ...selectedData,
                    workFlexibility: v,
                  })
                }
                clearable={false}
              />
            </div>
          </div>
        </div>
        <div className="buttons_bottom">
          <Button
            className="w-150 mr-3"
            size="sm"
            onClick={handleBack}
            style={{
              height:"33px"
            }}
          >
            Back
          </Button>
          <Button
            className="trivia-action-button-main w-150"
            disabled={nextBtnDisabled()}
            onClick={handleCreateTrivvy}
          >
            Create Trivvy
          </Button>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Loading(TrivvyCustomTemplateForm, axios));
